(() => {
  const trackerEndpoint = "https://nulkachuhjdzohkzwvly.supabase.co/functions/v1/mg-order-tracking";
  const escapeText = (value) => String(value ?? "");
  const stages = [
    ["MG_RECEIVED", "ORDINE RICEVUTO"],
    ["MG_RESTOCK", "COMPONENTI"],
    ["MG_QUEUE", "CODA LABORATORIO"],
    ["MG_ASSEMBLY", "ASSEMBLAGGIO"],
    ["MG_TESTING", "TEST E COLLAUDO"],
    ["MG_READY", "PRONTO"],
    ["MG_SHIPPED", "SPEDITO"]
  ];
  const stageDetails = [
    ["Abbiamo ricevuto e verificato i dati dell’ordine.", "Verifica disponibilità e compatibilità dei componenti.", "Quando il controllo iniziale è concluso."],
    ["Stiamo confermando e preparando tutti i componenti della build.", "Ingresso nella coda reale del laboratorio.", "Quando ogni componente necessario è disponibile."],
    ["La build è completa nei componenti ed è in attesa del banco di lavoro.", "Assemblaggio manuale da parte dei tecnici.", "Appena si libera il banco assegnato al tuo ordine."],
    ["I tecnici stanno assemblando, cablando e rifinendo il PC.", "Stress test, controllo temperature e collaudo.", "Quando l’assemblaggio e i controlli visivi sono conclusi."],
    ["Il PC è sotto test per stabilità, temperature e prestazioni reali.", "Preparazione finale e imballaggio protetto.", "Al superamento di tutti i test previsti."],
    ["La build ha superato i controlli ed è pronta per essere affidata al corriere.", "Generazione della spedizione e del tracking.", "Appena il pacco viene preso in carico dal corriere."],
    ["Il pacco è stato affidato al corriere.", "Puoi seguire gli aggiornamenti dal tracking ufficiale.", "Secondo le scansioni e le tempistiche del corriere."]
  ];

  const renderResult = (root, payload) => {
    root.replaceChildren();
    if (!payload || payload.ok !== true) {
      const error = document.createElement("div");
      error.className = "mg-order-error";
      error.textContent = payload?.message || "Non riusciamo a verificare questi dati. Controlla numero ordine ed email e riprova tra poco.";
      root.append(error);
      root.hidden = false;
      return;
    }

    const currentIndex = Math.max(0, stages.findIndex(([code]) => code === payload.status));
    const head = document.createElement("div");
    head.className = "mg-order-head";
    const left = document.createElement("span");
    const leftSmall = document.createElement("small");
    leftSmall.textContent = "ORDINE";
    const leftBold = document.createElement("b");
    leftBold.textContent = escapeText(payload.orderName);
    left.append(leftSmall, leftBold);
    const right = document.createElement("span");
    const rightSmall = document.createElement("small");
    rightSmall.textContent = payload.estimatedWindow ? "TEMPI INDICATIVI" : "STATO CONFERMATO";
    const rightBold = document.createElement("b");
    rightBold.textContent = escapeText(payload.estimatedWindow || payload.statusLabel || "In lavorazione");
    right.append(rightSmall, rightBold);
    head.append(left, right);

    const source = document.createElement("section");
    source.className = `mg-order-source${payload.estimated ? " is-estimate" : " is-confirmed"}`;
    const sourceMark = document.createElement("span");
    sourceMark.setAttribute("aria-hidden", "true");
    sourceMark.textContent = payload.estimated ? "≈" : "✓";
    const sourceCopy = document.createElement("div");
    const sourceTitle = document.createElement("b");
    const sourceText = document.createElement("p");
    if (payload.estimated) {
      const elapsed = Number.isFinite(Number(payload.businessDaysElapsed)) ? Number(payload.businessDaysElapsed) : 0;
      sourceTitle.textContent = "FASE STIMATA — NON È UN AGGIORNAMENTO MANUALE DEL LABORATORIO";
      sourceText.textContent = `La posizione mostrata è calcolata sui ${elapsed} giorni lavorativi trascorsi dall’ordine. Serve a orientarti: la fase reale può essere diversa finché il laboratorio non registra un aggiornamento.`;
    } else {
      sourceTitle.textContent = payload.statusSource === "fulfillment" ? "SPEDIZIONE CONFERMATA" : "STATO CONFERMATO DAL LABORATORIO";
      sourceText.textContent = payload.statusSource === "fulfillment"
        ? "Il pacco risulta affidato al corriere. Da questo momento fa fede il tracking ufficiale."
        : "Questa fase arriva dal gestionale Minimal Gamers e descrive lo stato effettivamente registrato per il tuo ordine.";
    }
    sourceCopy.append(sourceTitle, sourceText);
    source.append(sourceMark, sourceCopy);

    const progress = document.createElement("div");
    progress.className = "mg-order-progress";
    stages.forEach(([code, label], index) => {
      const item = document.createElement("div");
      item.className = `mg-order-step${index < currentIndex ? " is-complete" : ""}${index === currentIndex ? " is-active" : ""}`;
      const dot = document.createElement("i");
      const small = document.createElement("small");
      small.textContent = `FASE ${String(index + 1).padStart(2, "0")}`;
      const bold = document.createElement("b");
      bold.textContent = label;
      item.append(dot, small, bold);
      progress.append(item);
    });
    const detail = document.createElement("section");
    detail.className = "mg-order-now";
    const detailCopy = stageDetails[currentIndex] || stageDetails[0];
    const currentLabel = payload.detailLabel || stages[currentIndex]?.[1] || payload.statusLabel || "IN LAVORAZIONE";
    const currentDescription = payload.statusDetail || detailCopy[0];
    const nextLabel = payload.nextLabel || detailCopy[1];
    [
      [payload.estimated ? "FASE STIMATA OGGI" : "DOVE SI TROVA ORA", currentLabel],
      [payload.estimated ? "COSA INDICA QUESTA STIMA" : "COSA STIAMO FACENDO", currentDescription],
      ["PROSSIMO PASSAGGIO", nextLabel],
      ["COME LEGGERE I TEMPI", "La finestra 10–25 considera solo i giorni lavorativi; weekend, festivi e chiusure aziendali non vengono conteggiati."]
    ].forEach(([label, value]) => {
      const card = document.createElement("div");
      const small = document.createElement("small");
      const strong = document.createElement("strong");
      small.textContent = label;
      strong.textContent = value;
      card.append(small, strong);
      detail.append(card);
    });
    const clarification = document.createElement("p");
    clarification.className = "mg-order-clarification";
    clarification.textContent = payload.estimated
      ? "La dicitura “Spedito” appare soltanto dopo l’affidamento reale al corriere. Se l’ordine è ancora in lavorazione, la data resta una finestra indicativa e non un appuntamento di consegna."
      : "Lo stato confermato prevale sulla stima automatica. Le date restano indicative fino all’affidamento al corriere.";

    root.append(head, source, progress, detail, clarification);

    if (payload.trackingUrl) {
      const link = document.createElement("a");
      link.className = "mg-order-tracking-link";
      link.href = payload.trackingUrl;
      link.target = "_blank";
      link.rel = "noopener noreferrer";
      const label = document.createElement("span");
      const small = document.createElement("small");
      small.textContent = "SPEDIZIONE AFFIDATA A BRT";
      const bold = document.createElement("b");
      bold.textContent = payload.trackingNumber ? `TRACKING ${escapeText(payload.trackingNumber)}` : "APRI IL TRACKING UFFICIALE";
      label.append(small, bold);
      const logo = document.createElement("img");
      logo.src = root.closest("[data-mg-order-tracker]")?.dataset.brtLogo || "";
      logo.alt = "BRT";
      link.append(label, logo);
      root.append(link);
    }
    root.hidden = false;
  };

  const initTracker = (root) => {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";
    const form = root.querySelector("[data-mg-tracker-form]");
    const result = root.querySelector("[data-mg-tracker-result]");
    if (!form || !result) return;
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const button = form.querySelector("button[type='submit']");
      const buttonLabel = button.querySelector("[data-mg-tracker-submit-label]");
      const data = new FormData(form);
      button.disabled = true;
      if (buttonLabel) buttonLabel.textContent = "CONTROLLO IN CORSO…";
      try {
        const response = await fetch(trackerEndpoint, {
          method: "POST",
          headers: { "Content-Type": "application/json", "Accept": "application/json" },
          credentials: "omit",
          body: JSON.stringify({ orderNumber: String(data.get("orderNumber") || "").trim(), email: String(data.get("email") || "").trim().toLowerCase() })
        });
        const payload = await response.json().catch(() => ({}));
        renderResult(result, response.ok ? payload : { ok: false, message: payload.message });
      } catch (_) {
        renderResult(result, { ok: false });
      } finally {
        button.disabled = false;
        if (buttonLabel) buttonLabel.textContent = "CONTROLLA STATO";
      }
    });
  };

  const initEmbedded = (root) => {
    if (root.dataset.ready === "true") return;
    root.dataset.ready = "true";
    const frame = root.querySelector("[data-mg-embedded-frame]");
    const fallback = root.querySelector("[data-mg-embedded-fallback]");
    if (!frame || !fallback) return;
    const timer = window.setTimeout(() => { fallback.hidden = false; }, 9000);
    frame.addEventListener("load", () => window.clearTimeout(timer), { once: true });
    frame.addEventListener("error", () => { fallback.hidden = false; }, { once: true });
    if (!root.querySelector(".mg-embedded-rescue")) {
      const rescue = document.createElement("a");
      rescue.className = "mg-embedded-rescue";
      rescue.href = frame.src;
      rescue.target = "_blank";
      rescue.rel = "noopener noreferrer";
      rescue.textContent = "SCHERMO VUOTO? APRI DIRETTAMENTE ↗";
      root.append(rescue);
    }
  };

  const initCategoryJump = (root) => {
    if (!window.location.pathname.includes("/collections/")) return;
    const products = root.querySelector(".mg-category-links--products");
    if (!products || root.querySelector(".mg-category-jump")) return;
    products.id = products.id || "mg-prodotti";
    const jump = document.createElement("a");
    jump.className = "mg-category-jump";
    jump.href = `#${products.id}`;
    jump.textContent = "VEDI I PRODOTTI ↓";
    const actions = root.querySelector(".mg-content-actions");
    if (actions) actions.append(jump);
    else (root.querySelector(".mg-content-hero > div:first-child") || root.querySelector(".mg-content-hero"))?.append(jump);
  };

  const init = (scope = document) => {
    scope.querySelectorAll("[data-mg-order-tracker]").forEach(initTracker);
    scope.querySelectorAll("[data-mg-embedded-app]").forEach(initEmbedded);
    scope.querySelectorAll(".mg-content-page").forEach(initCategoryJump);
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init()); else init();
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();

